import { ListItem } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { formatDate } from '../../../utils/dateUtil';

const AvailabilityDateTimeMore = ({ session }) => {
  const { start_date: startDate, end_date: endDate } = session;

  return (
    <ListItem fontSize="xs">
      {formatDate(startDate, {
        dateStyle: 'medium',
      }) + ', '}
      <Trans>from</Trans>
      {' ' +
        formatDate(startDate, {
          timeStyle: 'short',
        }) +
        ' '}
      <Trans>to</Trans>
      {' ' +
        formatDate(endDate, {
          timeStyle: 'short',
        })}
    </ListItem>
  );
};

export default AvailabilityDateTimeMore;
